// src/components/Assets/Templates/Normal1/normal1.js
export default `
 <!DOCTYPE html>
<html lang="en" dir="ltr" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<meta charset="utf-8">
<meta http-equiv="X-UA-Compatible" content="IE=edge">
<meta name="viewport" content="width=device-width,initial-scale=1">
<meta name="format-detection" content="telephone=no, date=no, address=no, email=no, url=no">
<meta name="x-apple-disable-message-reformatting">
<meta name="color-scheme" content="light dark">
<meta name="supported-color-schemes" content="light dark">
<title>Srihari Muppalla</title>
<!--[if mso]>
<noscript>
<xml>
<o:OfficeDocumentSettings>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml>
</noscript>
<style>
table { border-collapse: collapse; mso-table-lspace: 0px; mso-table-rspace: 0px; }
sup { font-size:100%;line-height:100%;mso-text-raise: 4px;}
li {margin-left:-23px !important}
.nostyle{list-style: none !important}
</style>
<![endif]-->

<style>
:root {
color-scheme: light dark;
supported-color-schemes: light dark;
}
/* Fix for Outlook links color fix for links and visited links */
span.MsoHyperlink {color: inherit !important;mso-style-priority: 99 !important;text-decoration: underline !important;}

span.MsoHyperlinkFollowed {color: inherit !important;mso-style-priority: 99 !important;}
/* normalise link attributes in Outlook app iOS/Android - to match the parent element */
body[data-outlook-cycle] a {color: inherit !important;text-decoration: none !important;}
/* normalise link attributes in Apple Mail / iOS Mail apps - to match the parent element */
a[x-apple-data-detectors] {color: inherit!important;text-decoration: none!important;font-size: inherit!important;font-family: inherit!important;font-weight: inherit!important;line-height: inherit!important;}
#root [x-apple-data-detectors=true],a[x-apple-data-detectors=true]{
color: inherit !important;text-decoration: inherit !important;}
#main #inner a[x-apple-data-detectors]{color: inherit !important;
text-decoration: inherit !important;}
a[href^=tel], #MessageViewBody a, a[x-apple-data-detectors], #body a, .link {color: inherit;text-decoration: none;font-size: inherit;
font-family: inherit;font-weight: inherit;line-height: inherit;}
[data-outlook-cycle] [x-apple-data-detectors-type="calendar-event"] {color: inherit !important;-webkit-text-decoration-color: inherit !important;text-decoration: none !important;}
/* normalise link attributes in Gmail - to match the parent element */
u + #body a {color: inherit;text-decoration: none;font-size: inherit;font-weight: inherit;line-height: inherit;}
#preheader,#preview-spacer {display: none;display:none!important;}
.applelink a{color: #000000 !important; text-decoration: none !important;}
ul {padding-left: 17px !important;}
ol {padding-left: 17px !important;}
hr{margin: 0 !important;}
.faux-absolute{max-height:0;position:relative;opacity:0.999;}
/*Mobile CSS*/
@media only screen and (max-width: 480px){

	.bgcolr{background-color: #e5f6fd !important; }
.w18{width: 33px !important;}
.w320{width: 400px !important;} 
	.mb20{margin-bottom: 20px !important;}
	.mtb16{margin-top: 16px !important; margin-bottom: 16px !important;}
.w100 {width: 100%!important; min-width: 100%!important; max-width: 1000px!important; height: auto!important;}
.img100 {width: auto!important; height: auto!important; display: block!important;}
.nomob {display: none!important;width: 0px!important;height: 0px!important;}
.show {display: block!important;overflow: visible!important;float: none!important;width: 100%!important;height: auto!important;max-height: inherit!important;}
.display-footer {display: table-footer-group!important;width: 100%!important;min-width: 100%!important;}
.display-header {display: table-header-group!important;width: 50%!important;min-width: 100%!important;}
.drop {width: 100%!important;float: left!important;display: block!important;}
.p15{padding: 15px 0 !important;}
.w88{width: 88% !important;}
.h10{height: 10px !important; line-height: 10px !important;}
.mt10{margin-top: 16px !important;}
.p16{padding: 16px !important;}
.pt25{padding-top: 25px !important;}
.w42{width: 42% !important;}
	.mb0{margin-bottom: 0px !important;}
	.mt0{margin-top: 0px !important;}
.w76{width: 76% !important;}
.w58{width: 58% !important}
.block{display: block !important;}
.img100w{width: 100% !important;}
.mb28{margin-bottom: 90px !important;}
.mb26{margin-bottom: 28px !important;}
	.mlr22{margin-left: 20px !important; margin-right: 20px !important;}
.mt18{margin-top: 18px !important;}
.mt22{margin-top: 22px !important;}
.mt16{margin-top: 8px !important;}
.pb26{padding-bottom: 26px !important;}

.ptb30{padding: 30px 0 !important;}
.mt40{margin-top: 40px !important;}
.mbanner {width: 400px !important; max-width: 400px !important; min-width: 400px !important; height: 480px !important; max-height: 480px !important; min-height: 480px!important;}
.text_center{text-align: center !important;}
.imgh52{height: 36px !important;}
	.mt68{margin-top: 68px !important;}
	.talgn{text-align: left !important;}
.pt26{padding-top: 26px !important;}
.mpt38{padding-top: 32px !important;}
.mpt26{margin-top: 12px !important; margin-bottom: 10px !important;}
.mt20{margin-top: 20px !important;}
.mb10{margin-bottom: 10px !important;}
.mb16{margin-top: 16px !important;}
.mt40{margin-top: 40px !important; margin-bottom: 40px !important;}
.pt32{padding-top: 32px !important;}
.pbot10{padding-bottom: 16px !important;}
.w94{width: 94% !important;}
.mpt40{margin-top: 62px !important;}
.plr24{padding: 0px 36px !important;}
	#menu-icon {
margin-right: 8% !important;
}  

.button {
width: 100% !important;
}



#navigation-container {    
margin-right: 1% !important;
margin-left: 1% !important;
font-size: 12px !important;
}    

.interactivity-beacon:checked + table #menu-icon,
.interactivity-beacon:checked + table .menu-icon {
display: block !important;
mso-hide: none !important;
max-height: none !important;
overflow: visible !important;
}
.interactivity-beacon:checked + table .ptop{padding-top: 0px!important;}
#navigation-menu:checked + #menu-icon .icon-middle {    
-webkit-transform: scaleX(0);  /* Android 4.4 */
transform: scaleX(0);
}

#navigation-menu:checked + #menu-icon .menu-icon {
width: 24px !important;
background-color: #dddddd !important;
}

#navigation-menu:checked + #menu-icon .icon-top {
-webkit-transform: translateX(9px) rotate(45deg); /* Android 4.4 */
transform: translateX(9px) rotate(45deg);    
}

#navigation-menu:checked + #menu-icon .icon-bottom {
-webkit-transform: translateX(9px) rotate(-45deg); /* Android 4.4 */  
transform: translateX(9px) rotate(-45deg);      
}  

.interactivity-beacon:checked + table #navigation-container {    
max-height: 0 !important; /* for accessibility */
overflow: hidden !important; /* for accessibility */
opacity: 0;
margin: 0 6% !important;
transition: max-height 0.3s ease, opacity 0.3s ease;  
}

.interactivity-beacon:checked + table #navigation-container a {
display: block !important;
font-size: 14px !important;
line-height: 3 !important;
border-bottom: 1px solid #e4e4e4;
}

.interactivity-beacon:checked + table .nav-decoration  {
display: none !important;
}

#navigation-menu:checked + label + #navigation-container {
max-height: 300px !important;
overflow: visible !important;
opacity: 1;
}  

#navigation-menu + label + #navigation-container:focus-within {
max-height: 300px !important;
overflow: visible !important;
opacity: 1;
}  
}
/*Mobile CSS*/
@media only screen and (max-width: 410px){
.mpt40{margin-top: 40px !important;}
.w320{width: 320px !important;}
.w18{width: 26px !important;}
.pt60{padding-top: 60px !important;}
.pt36{padding-top: 32px !important;}
.mb28{margin-bottom: 16px !important;}
.mbanner {width: 320px !important; max-width: 320px !important; min-width: 320px !important; height: 384px !important; max-height: 384px !important; min-height: 384px!important;}
.imgh52{height: 42px !important;}
.width38{width: 38px !important;}
.width12{width: 12px !important;}
.font18{font-size: 18px !important; line-height: 22px !important; padding-bottom: 14px !important;}
.pt26{padding-top: 10px !important;}
.mt40{margin-top: 36px !important;}
.mtop72{margin-top: 72px !important;}
.plr24{padding: 0px 8px !important;}

}
</style>
<style>
u + .body .gmail-blend-screen { background:#000; mix-blend-mode:screen; }
u + .body .gmail-blend-difference { background:#000; mix-blend-mode:difference; }
@media (prefers-color-scheme: dark ) {
.mainbg { background-color: #000 !important; }
.darkmode { background-color: #272623 !important; }
	.white{background-color: #ffffff !important;}
h1, h2, p, span, a, b, ul, li, ol, h6, .mob { color: #ffffff !important; }
.darktext h1, .darktext h2, .darktext p, .darktext span, .darktext a{ color: #000 !important; }
.textBlue{color: #223c83 !important;}
.textBlack{color: #000 !important;}
	.bluebg{background-color: #add6d8 !important;}
	.greytext{color: #ffffff !important;}
/* OUTLOOK APP (ANDROID) DARK MODE STYLES */
[data-ogsc] .mainbg { background-color: #000 !important; }
[data-ogsc] .darkmode { background-color: #272623 !important; }
	[data-ogsc] .white { background-color: #ffffff !important; }
[data-ogsc] h1, [data-ogsc] h2, [data-ogsc] h6, [data-ogsc] p, [data-ogsc] span, [data-ogsc] a, [data-ogsc] b, [data-ogsc] ul, [data-ogsc] li, [data-ogsc] ol { color: #ffffff !important; }
[data-ogsc] .darktext h1, [data-ogsc] .darktext h2, [data-ogsc] .darktext p, [data-ogsc] .darktext span, .darktext li{ color: #000 !important; }
[data-ogsc].textBlue{color: #223c83 !important;}
[data-ogsc].textBlack{color: #000 !important;}
[data-ogsc].bluebg{background-color: #add6d8 !important;}
}
</style>
</head>
<body class="body mainbg" style="margin: 0; padding: 0; background-color: #e8e8e8;">
<div id="preheader" style="display: none; font-size: 0; line-height: 0; mso-hide: all; color: #e3e3e3;">Srihari Muppalla</div>

<div id="preview-spacer" style="display: none; font-size: 0; line-height: 0; mso-hide: all; color: #e3e3e3;">&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;&#847; &#847; &#847; &#847; &#847; &#847;</div>
<div role="article" aria-roledescription="email" aria-label="email name" lang="en" dir="ltr" style="font-size:16px; font-size:1rem; font-size:max(16px, 1rem)">
<table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" bgcolor="#e8e8e8" class="mainbg">
<tr>
<td align="center">
<div id="main">
<div id="inner">
	<!--[if !mso]><!-->
<input type="checkbox" class="interactivity-beacon" checked="checked" style="display: none; mso-hide: all;">
<!--<![endif]-->
<table width="600" border="0" cellspacing="0" cellpadding="0" style="width: 600px;" role="presentation" class="w320 darkmode" bgcolor="#ffffff">
<tbody>
<tr>
<td align="center" valign="top">
<table width="97%" border="0" cellspacing="0" cellpadding="0" style="width: 97%" class="w280" role="presentation">
<tbody>
<tr>
<td align="center" valign="top" style="font-family: Arial, Helvetica, sans-serif; text-align:center; font-size:14px; line-height: 18px; text-align: center; color: #000000; padding: 10px 0px 10px 0px;"><a href="https://srihari.site" target="_blank" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; font-size: 10px; line-height: 15px; text-decoration: none; text-transform: uppercase; display: inline;">View online</a></td>
</tr>

</tbody>
</table>
</td>
</tr>
<tr>
<td align="center" valign="top">
<table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
	<tr><td class="darkmode" style="padding: 20px 0px; font-size: 26px; line-height: 30px; font-family: Arial, Helvetica, sans-serif; text-align: center; font-weight: bold; background-color: #F5F5F5; color: #007BFF;">Srihari Muppalla</td></tr>
	<tr>
<td class="container ptop darkmode" style="padding-top: 4px; padding-right: 0; padding-bottom: 0; padding-left: 0; border-width: 0; border-style: none; vertical-align: top; text-align: left; font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; width: 100%; background-color: #ffffff;">                  

<!--[if !mso]><!-->
<input type="checkbox" id="navigation-menu" style="display: none; mso-hide: all;">        

<label id="menu-icon" for="navigation-menu" title="Menu" role="button" style="display: none; mso-hide: all; max-height: 0; overflow: hidden; cursor: pointer; width: 40px; float: right; margin-right: 6%; padding-top: 5px; padding-right: 0; padding-bottom: 5px; padding-left: 5px; box-sizing: border-box;">
<span class="description" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #ffffff; font-size: 0; line-height: 0; max-height: 0; overflow: hidden;">Menu</span>
<span class="menu-icon icon-top" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: none; mso-hide: all; max-height: 0; background-color: #000000; width: 100%; border-radius: 3px; height: 3px; margin-bottom: 5px; transition: all 0.3s ease; -webkit-transform-origin: left center; transform-origin: left center;"></span>
<span class="menu-icon icon-middle" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: none; mso-hide: all; max-height: 0; background-color: #000000; width: 100%; border-radius: 3px; height: 3px; margin-bottom: 5px; transition: all 0.3s ease; -webkit-transform-origin: left center; transform-origin: left center;"></span>
<span class="menu-icon icon-bottom" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: none; mso-hide: all; max-height: 0; background-color: #000000; width: 100%; border-radius: 3px; height: 3px; margin-bottom: 5px; transition: all 0.3s ease; -webkit-transform-origin: left center; transform-origin: left center;"></span>                      
</label>
<!--<![endif]-->

<!-- note multiple nav-decoration spans used to bypass outlook app ios android collapsing starting consecutive nbsp - do not combine -->

<p id="navigation-container" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; mso-line-height-rule: exactly; display: block; padding: 0; margin-right: 0; margin-left: 0; margin-top: 4px; margin-bottom: 12px; text-align: center; clear: both; white-space: normal; word-spacing: 0.08em; font-size: 12px; line-height: 24px; text-transform: uppercase; text-decoration: none;">  

<a href="https://srihari.site" target="_blank" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; text-transform: uppercase; text-decoration: none; display: inline;">CREDIT CARD</a>                  


<span class="nav-decoration" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">&nbsp; </span><span class="nav-decoration" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">|&nbsp;</span><span class="nav-decoration" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">&nbsp;</span>

<a href="https://srihari.site" target="_blank" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; text-transform: uppercase; text-decoration: none; display: inline;">LOANS</a>

<span class="nav-decoration nav-decoration-hide" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">&nbsp; </span><span class="nav-decoration nav-decoration-hide" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">|&nbsp;</span><span class="nav-decoration nav-decoration-hide" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">&nbsp;</span>

<span class="navigation-second-row" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">

<a href="https://srihari.site" target="_blank" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; text-transform: uppercase; text-decoration: none; display: inline;">INSURANCE</a>

<span class="nav-decoration" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">&nbsp; </span><span class="nav-decoration" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">|&nbsp;</span><span class="nav-decoration" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">&nbsp;</span>

<a href="https://srihari.site" target="_blank" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; text-transform: uppercase; text-decoration: none; display: inline;">TRAVEL</a>

<span class="nav-decoration" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">&nbsp; </span><span class="nav-decoration" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">|&nbsp;</span><span class="nav-decoration" aria-hidden="true" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; display: inline;">&nbsp;</span>

<a href="https://srihari.site" target="_blank" style="font-family: Arial, Helvetica, sans-serif; font-weight: 400; color: #000000; text-transform: uppercase; text-decoration: none; display: inline;">SAVINGS</a>

</span>
</p>  

</td>
</tr>
<tr>
<td class="mainbg" align="center" bgcolor="#e5f6fd">
<table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" style="width: 100%; background-color: #e5f6fd;">
<tbody>
<tr>
<td valign="top" style="padding-bottom: 0px;" class="mpb0"><div class="over-mob" style="max-height:350px; margin: 0 auto; text-align: center;background: #36c5ef;"><!--[if !mso 9]><!--><img class="nomob" src="https://sriharim.in/Assets/normal/n3-banner.jpg" width="600" height="400" border="0" alt="Sri" style="vertical-align: top; background-color: #e5f6fd; display: block;border: 0;"/><!--<![endif]--><!--[if mso]><img src="https://sriharim.in/Assets/normal/n3-banner.jpg" alt="Sri" width="600" height="400" style="display: block; border: 0;" /><!--<![endif]-->
<!--[if !mso]><!--><span class="show" style="display: none; max-height: 0px; overflow: hidden;margin: 0;"><img src="https://sriharim.in/Assets/normal/n3-banner.jpg" width="320" style="width: 320px; max-width: 320px; display:block; border: 0px; margin: 0 auto;" border="0" alt="Sri"/></span><!--<![endif]--></div>
<table role="presentation" class="faux-absolute reset" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="position:relative; opacity:0.999;">
<tr>
<td valign="top" align="center" style="" class="mpt0"><!--[if mso]>
<v:rect xmlns:v="urn:schemas-microsoft-com:vml" stroked="false" filled="false" style="width:600px; height: auto;">
<v:textbox inset="0,-133px,0,0" style="mso-fit-shape-to-text:true;">
<![endif]-->
<table width="83%" border="0" cellspacing="0" cellpadding="0" align="center" style="width: 83%;" class="w100" role="presentation">
<tbody>
<tr>
<td align="left" bgcolor="#ffffff" style="padding-top: 23px; padding-bottom: 24px;" class="mpt38 darkmodeoverlay bgcolr darkmode">
<table width="92%" align="center" border="0" cellspacing="0" cellpadding="0" class="w255" style="width: 92%;" role="presentation">
<tbody>
<tr>
<td align="center">
<h1 style="margin: 0; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 15px; line-height: 20px; color: #000000; font-weight: normal;">Dear User,</h1>  
<p style="margin: 0; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 15px; line-height: 20px; color: #000000; margin-top: 8px;" >Text 1 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> 
<p style="margin: 0; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 15px; line-height: 20px; color: #000000; margin-top: 16px;" class="mpt26">Text 1 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
<p style="margin: 0; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 15px; line-height: 20px; color: #000000; margin-top: 14px;" class="mpt26">Text 1 Lorem ipsum dolor sit amet, consectetur adipiscing elit</p> 
<p style="margin: 0; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 15px; line-height: 20px; color: #000000; margin-top: 14px; margin-bottom: 6px;">All the best,</p> 
<p style="margin: 0; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: 18px; color: #000000; margin-top: 0px;" class="mb0">Srihari Muppalla</p> 
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
	<p class="nomob" style="margin: 16px 0; font-size: 1px; line-height: 1px;">&nbsp;</p> 
<p style="margin: 0;"><a href="https://srihari.site" target="_blank" style="text-decoration: none;" title="SPEND WISELY"><img src="https://ik.imagekit.io/sriHari143/templates/I1/image-cta-updt_FFJwFnu7d5.png?updatedAt=1742534063574" alt="Sri" width="600" height="349" style="display: block; border: 0;" class="nomob banner"/><!--[if !mso]><!--><span class="show" style="display: none; max-height: 0px; overflow: hidden;margin: 0;"><img src="https://ik.imagekit.io/sriHari143/templates/I1/mob-img-1_Igx63uPeES.png?updatedAt=1742534318217" width="320" style="width: 100%; max-width: 400px; display:block; border: 0px; margin: 0 auto;" border="0" alt="Sri"/></span><!--<![endif]--></a></p>
<!--[if mso]>
</v:textbox>
</v:rect>
<![endif]--></td>
</tr>
</table>
</td>
</tr>
</tbody>
</table>  
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td class="mainbg" align="center" bgcolor="#e7f3f3">
<table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" style="width: 100%" class="w100">
<tbody>
<tr>
<td align="center">
<table width="83%" border="0" cellspacing="0" cellpadding="0" role="presentation" style="width: 83%" class="w100">
<tbody>
<tr>
<td align="center" style="padding-top: 34px;">
<table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" class="w76">
<tbody>
<tr>
<th class="display-footer" valign="middle" align="center" width="50%" style="width: 50%; font-weight: normal;">
<table align="left" width="235" border="0" cellspacing="0" cellpadding="0" style="width: 235px;" role="presentation" class="w100">
<tbody>
	<!--[if mso]>
<tr>
<td align="center" valign="top" height="10" class="nomob" style="height: 10px;">&nbsp;</td>  
</tr><![endif]-->
<tr>
<td align="center" valign="top">
<h3 style="margin: 0; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 16px; line-height: 22px; color: #5cadb1; margin-top: 0px; font-weight: bold;" class="text_center mt22 talgn">UPGRADE YOUR TRAVEL EXPERIENCE!</h3>
<p class="text_center mt16 talgn" style="margin: 0; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 16px; line-height: 20px; color: #000000; margin-top: 14px;">We&rsquo;ve put together a collection of handy holiday tips that will have you packing like a pro and finding your way round the airport like a seasoned traveller!</p><p style="margin: 0; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 15px; line-height: 20px; color: #000000; margin-top: 20px; margin-bottom: 8px;"><a href="https://srihari.site" target="_blank" title="TOP TIPS THIS WAY"><img src="https://ik.imagekit.io/sriHari143/templates/I1/top-tip-desk_gB7rLNv6WF.png?updatedAt=1742534564511" width="214" style="width: 214px; height: auto; border: 0px; display: block;" alt="TOP TIPS THIS WAY" class="nomob"><!--[if !mso]><!--><span class="show" style="display: none; max-height: 0px; overflow: hidden;margin: 0;"> <img src="https://ik.imagekit.io/sriHari143/templates/I1/top-tip-desk_gB7rLNv6WF.png?updatedAt=1742534564511" width="245" style="display: block; max-width: 300px; margin: 0 auto; width: 100%" alt="TOP TIPS THIS WAY" /></span><!--<![endif]--></a></p> </td>
</tr>
</tbody>
</table>
</th>
<th class="display-header mainbg" bgcolor="#e7f3f3" align="right" width="50%" style="width: 50%; font-weight: normal;"><p style="margin: 0;"><img src="https://ik.imagekit.io/sriHari143/templates/I1/img-1_IxIcjC4EcS.png?updatedAt=1742534063582" width="244" style="width: 244px; height: auto; border: 0px; display: block;" alt="" class="nomob"><!--[if !mso]><!--><span class="show" style="display: none; max-height: 0px; overflow: hidden;margin: 0;"> <img src="https://ik.imagekit.io/sriHari143/templates/I1/mob-grl_wDhYT8kPfN.png?updatedAt=1742534317836" width="245" style="display: block; max-width: 300px; width: 100%; margin: 0 auto;"  alt="" /></span><!--<![endif]--></p></th>
</tr>
</tbody>
</table>
</td>
</tr>
	
</tbody>
</table>
<p style="margin: 16px 0; font-size: 1px; line-height: 1px;">&nbsp;</p> 
<table align="center" width="83%" border="0" cellspacing="0" cellpadding="0" role="presentation" style="width: 83%" class="w76">
<tbody>
<tr>
<th class="drop" bgcolor="#e7f3f3" align="left" width="50%" style="width: 50%; font-weight: normal;"><p style="margin: 0;"><img src="https://ik.imagekit.io/sriHari143/templates/I1/img-2_ms3mX3Hjb.png?updatedAt=1742534063137" width="250" style="width: 250px; height: auto; border: 0px; display: block;" alt="" class="nomob"><!--[if !mso]><!--><span class="show" style="display: none; max-height: 0px; overflow: hidden;margin: 0;"> <img src="https://ik.imagekit.io/sriHari143/templates/I1/mob-img-2_h39_ZgzQo.png?updatedAt=1742534317829" width="245" style="display: block;max-width: 300px; width: 100%" alt="" /></span><!--<![endif]--></p></th>  
<th class="drop" bgcolor="#f6c0a7" align="center" width="50%" style="width: 50%; font-weight: normal;">
<table align="center" width="210" border="0" cellspacing="0" cellpadding="0" style="width: 210px;" role="presentation" class="w100">
<tbody>
<tr>
<td align="center" class="darktext" style="padding-bottom: 10px;">
<p style="margin: 0;" class="mt22"><img src="https://ik.imagekit.io/sriHari143/templates/I1/img-3_WCY-BuKcwI.png?updatedAt=1742534063472" width="162" style="width: 162px; height: auto; display: block; border: 0px;" alt="Make my day"></p>
<p class="text_center mt16 mlr22" style="margin: 0; text-align: center; font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: 20px; color: #000000; margin-top: 18px; margin-bottom: 28px;">Summer&rsquo;s here, so you might be planning to have some days out. We&rsquo;ve put together a selection of ideas to keep you entertained for the day. </p><p class="mtb16" style="margin: 0;"><a href="https://srihari.site" target="_blank" title="WHERE WILL YOU GO?"><img src="https://ik.imagekit.io/sriHari143/templates/I1/whertogo-updt-desk__0Z7WLWrVG.png?updatedAt=1742534564179" width="210" style="width: 210px; height: auto; border: 0px; display: block;" alt="WHERE WILL YOU GO?" class="nomob"><!--[if !mso]><!--><span class="show" style="display: none; max-height: 0px; overflow: hidden; margin: 0;"> <img src="https://ik.imagekit.io/sriHari143/templates/I1/whertogo-updt-desk__0Z7WLWrVG.png?updatedAt=1742534564179" width="210" style="display: block; max-width: 210px; width: 210px;" alt="WHERE WILL YOU GO?" /></span><!--<![endif]--></a></p><!--[if mso]><p style="margin:0;"><span style="font-size:0; line-height: 0">&nbsp;</span></p><![endif]--></td>
</tr>
</tbody>
</table>
<!--[if mso]><p style="margin:0;"><span style="font-size:0; line-height: 0">&nbsp;</span></p><![endif]-->
</th>
</tr>
</tbody>
</table>
	<!--[if gt mso 15]>
<tr><td style="font-size:0;line-height:0;">&nbsp;</td></tr>
<![endif]-->

<table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" style="width: 100%" class="w100">
<tbody>
<tr>
<td align="center" style="padding-top: 34px;">
<table width="100%" border="0" cellspacing="0" cellpadding="0" role="presentation" class="w100">
<tbody>
<tr>

<th class="drop" bgcolor="#add6d8" align="left" width="230" style="width: 230px; font-weight: normal;"><p style="margin: 0; margin-left: 0px; margin-top: px; margin-bottom: px;"><img src="https://ik.imagekit.io/sriHari143/templates/I1/img-4_XfguVqr8m.png?updatedAt=1742534063580" width="188" style="width: 188px; height: auto; border: 0px; display: block;" alt="" class="nomob"><!--[if !mso]><!--><span class="show" style="display: none; max-height: 0px; overflow: hidden;margin: 0;"> <img src="https://ik.imagekit.io/sriHari143/templates/I1/mob-last_Qdy3WFOjaY.png?updatedAt=1742534317997" width="100%" style="display: block; max-width: 100%; margin: 0 auto;" alt="" /></span><!--<![endif]--></p></th>
<th bgcolor="#add6d8" class="drop" valign="middle" align="center" style="font-weight: normal;">
<table align="left" width="326" border="0" cellspacing="0" cellpadding="0" style="width: 326px;" role="presentation" class="w100">
<tbody>
<!--[if mso]>
<tr>
<td align="center" valign="top" height="10" class="nomob" style="height: 15px;">&nbsp;</td>  
</tr><![endif]-->
<tr><td valign="top" align="left">
	<table width="80%" border="0" cellspacing="0" cellpadding="0" role="presentation" style="width: 80%" class="w100">
  <tbody>
    <tr>
<td align="center" valign="top"><h3 style="margin:10px; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 21px; line-height: 25px; color: #000000; font-weight: bold;" class="text_center mt22 plr24">ESCAPE IN STYLE</h3></td>
</tr>
  </tbody>
</table>

	</td></tr>
<tr>
<td align="center" valign="top">
<p class="text_center mt16 plr24" style="margin:0 10px; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: 20px; color: #000000; margin-top: 18px;">Text 1 Lorem ipsum dolor sit amet, consectetur adipiscing elit</p><p class="text_center mt16 plr24" style="margin: 0 10px; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: 20px; color: #000000; margin-top: 14px;">Text 1 Lorem ipsum dolor sit amet, consectetur adipiscing elit Text 1 Lorem ipsum dolor sit amet.</p><p class="text_center mt16 plr24" style="margin: 0 10px; text-align: left; font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: 20px; color: #000000; margin-top: 14px; margin-bottom: 20px;">Text 1 Lorem ipsum dolor sit amet, consectetur adipiscing elit Text 1 Lorem ipsum dolor sit amet.</p> </td>
</tr>
</tbody>
</table>
</th>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>

</td>
</tr>
<tr>
<td class="darkmode" bgcolor="#ffffff" align="center" style="padding-top: 20px; padding-bottom: 20px;">
<table align="center" width="100" border="0" cellspacing="0" cellpadding="0" role="presentation">
<tbody>
<tr>
<td align="center"><a href="http://srihari.site" target="_blank" title="Like" style="display: inline-block;"><img src="https://ik.imagekit.io/sriHari143/templates/I1/facebook_knxzBpZla3.png?updatedAt=1742534063801" alt="Facebook" width="40" height="40" style="display: block; border: 0;"></a></td>
<td width="19" style="width: 19px;">&nbsp;</td>
<td><a href="http://srihari.site" target="_blank" title="Follow" style="display: inline-block;"><img src="https://ik.imagekit.io/sriHari143/templates/I1/twitter_6JmL77p4dA.png?updatedAt=1742534063459" alt="Twitter" width="40" height="40" style="display: block; border: 0;"></a></td>
</tr>
</tbody>
</table>  
</td>  
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</td>
</tr>
</table>
</div>
</body>
</html>
`;